/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

function CDMCollectionsGrid({ requests }: { requests: any[] }) {
  const nf = Intl.NumberFormat();
  const collections: any[] = [];
  const denominations: any[] = [];

  const denomsGrandTotals: any[] = [];

  let decNetTotal = 0;
  let amtNetTotal = 0;
  let diffNetTotal = 0;
  let netNotes = 0;

  requests.forEach((req) => {
    decNetTotal += req.declaredAmount;
    amtNetTotal += req.totalAmount;
    diffNetTotal += req.difference;

    req.denominations.forEach((rep: any) => {
      const denom = denominations.find(
        (dnm) => dnm.denomination === rep.denomination
      );

      if (!denom) {
        denominations.push({ denomination: rep.denomination });
      }
    });

    const denoms: any = {};
    let notesCount = 0;

    req.denominations.forEach((rep: any) => {
      denoms[rep.denomination] = rep.count;
      notesCount += rep.count;
    });

    netNotes += notesCount;

    const collInfo = {
      serialNo: req.serialNo,
      customer: req.customer,
      locationCode: req.locationCode,
      locationName: req.locationName,
      serviceDate: req.serviceDate,
      declaredAmount: req.declaredAmount,
      totalAmount: req.totalAmount,
      difference: req.difference,
      denoms,
      notesCount,
      remarks: req.remarks,
    };

    collections.push(collInfo);

    denomsGrandTotals.push(denoms);
  });

  return (
    <div className="w-full">
      <table width="100%">
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Sr. #
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Customer Name
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Location Code
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Location
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Service Date
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Declared Amount
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Denominations
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Bank Notes
            </th>
            <th
              rowSpan={2}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Total Amount
            </th>
            <th
              rowSpan={2}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Difference
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Remarks
            </th>
          </tr>
          <tr>
            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`repl${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {collections.map((res, i) => {
            return (
              <tr key={`row${i}`}>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                    width: "80px",
                  }}
                >
                  {res.serialNo}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.customer}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.locationCode}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.locationName}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.serviceDate}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.declaredAmount ? nf.format(res.declaredAmount) : 0}
                </td>

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.denoms[denom] ? nf.format(res.denoms[denom]) : 0}
                    </td>
                  );
                })}

                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.notesCount ? nf.format(res.notesCount) : 0}
                </td>

                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.totalAmount ? nf.format(res.totalAmount) : 0}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.difference ? nf.format(res.difference) : 0}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {res.remarks}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td
              colSpan={5}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Total
            </td>

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(decNetTotal)}
            </td>

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              denomsGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(netNotes)}
            </td>

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(amtNetTotal)}
            </td>

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(diffNetTotal)}
            </td>

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default React.memo(CDMCollectionsGrid);
